import React from "react";
import ReactTimeout from "react-timeout";
import styled from "styled-components";
import spinner from "../../assets/spinner.svg";
import { compose, withState, withHandlers } from "recompose";
import check from "../../assets/check-white.png";
import { getThemeColor } from "../utils";

const Subscribe = styled.form`
  display: flex;
  padding-bottom: 2.8125rem;

  ${props => props.theme.media.mobile`
    display: flex;
    flex-direction: column;
    padding-bottom: 1.5625rem;
  `};

  ${props => props.theme.media.tablet`
    padding-bottom: 1.5625rem;
  `};
`;

const EmailInput = styled.input`
  margin-right: 0.9375rem;
  border: 0;
  outline: 0;
  padding-left: 1rem;
  padding-bottom: .25rem;
  min-width: 12.375rem;
  background-color: transparent;
  border-bottom: 1px solid ${getThemeColor("white")};
  -webkit-text-fill-color: ${getThemeColor("white")};
  caret-color: ${getThemeColor("white")};
  font-size: .75rem;
  font-weight: 400;
  border-radius: 0;

  ${props => props.theme.media.tablet`
    min-width: 9.375rem;
  `};

  ${props => props.theme.media.mobile`
    margin-bottom: .625rem;
    min-width: 9.375rem;
  `};
`;

const Button = styled.button`
  height: 2rem;
  min-width: 6.3125rem;
  border-radius: 0;
  border: 1px solid ${getThemeColor("white")};
  background: ${getThemeColor("purpleDark")};
  color: ${getThemeColor("white")};
  font-size: .75rem;
  font-weight: 400;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const enhance = compose(
  ReactTimeout,
  withState("email", "onEmailChange", ""),
  withState("buttonState", "onButtonStateChange", ""),
  withHandlers({
    onEmailSubmit: ({
      onButtonStateChange,
      setTimeout,
      buttonState,
      onEmailChange
    }) => () => {
      onButtonStateChange("loading");
      setTimeout(() => {
        onButtonStateChange("success");
      }, 1000);
    }
  })
);

export default enhance(({ email, onEmailChange, buttonState, onEmailSubmit }) =>
  <Subscribe
    action="https://contraline.us17.list-manage.com/subscribe/post"
    method="POST"
  >
    <input type="hidden" name="u" value="13cab056a773f8cbcff5f7549" />
    <input type="hidden" name="id" value="eddaefea6c" />
    <EmailInput
      type="email"
      placeholder="Sign up for updates"
      autocapitalize="off"
      autocorrect="off"
      name="MERGE0"
      id="MERGE0"
      size="25"
      value={email}
      onChange={e => onEmailChange(e.target.value)}
    />
    <Button onClick={onEmailSubmit}>
      {buttonState === "loading" &&
        <img height={12} src={spinner} style={{ paddingRight: 8 }} />}
      {buttonState === "success" &&
        <img
          src={check}
          style={{
            height: 16,
            display: "inline-block",
            paddingRight: 8,
            color: "white"
          }}
        />}
      {buttonState === "success" ? "Subscribed" : "Subscribe"}
    </Button>
  </Subscribe>
);



// WEBPACK FOOTER //
// ./src/components/SignupForm.js